<template>
  <v-dialog :value="visible" width="500" persistent>
    <v-card>
      <v-card-title class="text-h6">Ny redaktör</v-card-title>

      <v-card-text>
        <v-form ref="form">
        <v-text-field
          label="För och efternamn"
          outlined
          :rules="[rules.required]"
          v-model="name"
        ></v-text-field>
        <v-text-field
          label="Email"
          outlined
          :rules="[rules.required, rules.email]"
          v-model="email"
        ></v-text-field>
        <v-text-field
          label="Lösenord"
          outlined
          :rules="[rules.required]"
          v-model="password"
        ></v-text-field>
        <v-text-field
          label="Upprepa lösenord"
          :rules="[rules.required, matchingPasswords]"
          outlined
          v-model="passwordRepeat"
        ></v-text-field>
      </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="onClose"> Avbryt </v-btn>
        <v-btn color="primary" :loading="loading" :disabled="!canSubmit" @click="onSave"> Spara </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { USER } from '@/assets/data/userRoles'
import { mapActions } from 'vuex'
export default {
  name: 'UserCreate',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    loading:false,
    name: '',
    email: '',
    password: '',
    passwordRepeat: '',
    rules: {
      required: (value) => !!value || 'Obligatoriskt',
      email: (value) => {
        const pattern =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Ogiltig e-mail.'
      },
    },
  }),
  computed: {
    canSubmit(){
      return this.name && this.email && this.password && this.passwordRepeat && this.password === this.passwordRepeat
    },
  },
  methods: {
    ...mapActions('user', { createUser:'create' }),
    matchingPasswords() {
      if (this.password === this.passwordRepeat) {
        return true;
      } else {
        return 'Lösenorden är inte lika.';
      }
    },
    onClear(){
      this.$refs.form.reset()
      this.name = ''
      this.email = ''
      this.password = ''
      this.passwordRepeat = ''
    },
    onClose() {
      this.$emit('close')
      this.onClear()
    },
   async onSave() {
    this.loading = true
    const newUser = {"id":crypto.randomUUID(), "admin_name":this.name,"admin_email":this.email, "admin_role":USER, admin_password:this.password}
    await this.createUser(newUser)
    this.$emit('update')
    this.loading = false
    this.onClose()
    },
  },
}
</script>

<style lang="less" scoped></style>